<template>
  <el-dialog
    fullscreen
    :visible="isShow"
    :modal="false"
    :show-close="false"
    custom-class="dialog-form"
  >
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 打印票据</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <div class="form-container" style="top:10px">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="样本册" required>
                <el-select v-if="formStatus" v-model="formData.sampleName" filterable placeholder="请选择产品">
                  <el-option v-for="item in products" :key="item.name" :label="item.name +'('+item.book_number+')'" :value="item.name+'('+item.book_number+')'"></el-option>
                </el-select>
                <span v-else>{{ formData.sampleName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="托盘号" required>
                <el-input
                  v-if="formStatus"
                  placeholder="托盘号"
                  v-model="formData.PT"
                ></el-input>
                <span v-else>{{ formData.PT }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                v-if="formStatus"
                icon="el-icon-search"
                type="primary"
                size="mini"
                @click="searchHandler"
                >搜索</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
          <div class="detail-title">
            <i class="em-icon-th-list"></i> 成品票据明细
          </div>
          <el-button
            v-if="formData.details.length > 0"
            type="success"
            size="mini"
            icon="el-icon-printer"
            round
            @click="printHandler"
            >打印票据</el-button
          >
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table
              :data="formData.details"
              size="mini"
              height="100%"
              style="width: 100%; border:1px solid #d1d1d1;"
              border
              header-row-class-name="list-header-row"
            >
              <el-table-column
                label="样本册"
                prop="sampleName"
                width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                label="托盘号"
                prop="pt"
                width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                label="日期"
                prop="createDateStr"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="时间"
                prop="createTimeStr"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="册/箱"
                prop="volumesPerCarton"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="箱/PT"
                prop="cartons"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="册数"
                prop="volumes"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="班长"
                prop="monitorName"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="组长"
                prop="leaderName"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column></el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <div
      id="print_area"
      style="position: relative; z-index: -1;text-align:center"
    >
      <div style="font-size:30pt">成品票</div>
      <div ref="codeItem" style="margin-top:10px"></div>
      <table
        border="1px solid #000"
        cellspacing="0"
        style="margin-top:10px;table-layout: fixed"
      >
        <tr>
          <th style="width:112px">时间</th>
          <th style="width:112px">册/箱</th>
          <th style="width:112px">箱/PT</th>
          <th style="width:112px">册数</th>
          <th style="width:112px">班长</th>
          <th style="width:112px">组长</th>
        </tr>
        <tr v-for="(item, index) in arrayPrint.details" :key="index">
          <td>{{ item.createTimeStr }}</td>
          <td>{{ item.volumesPerCarton }}</td>
          <td>{{ item.cartons }}</td>
          <td>{{ item.volumes }}</td>
          <td>{{ item.monitorName }}</td>
          <td>{{ item.leaderName }}</td>
        </tr>
      </table>
      <div style="margin-top:10px;font-size:30pt;font-weight: bold;">
        <span style="width:100px;">样本册：</span
        ><span style="width:320px;">{{
          arrayPrint.sampleName
        }}</span>
      </div>
      <div style="margin-top:10px;font-size:30pt;font-weight: bold;">
        <span style="width:100px;">日期：</span
        ><span style="width:320px;">{{
          arrayPrint.createDateStr
        }}</span>
      </div>
      <div style="margin-top:80px;font-size:30pt;font-weight: bold;">
        <span style="width:100px;">托盘号：</span
        ><span style="width:320px;">{{ arrayPrint.PT.split('.')[1] !== undefined ? arrayPrint.PT.split('.')[1].replace(/\b(0+)/gi,"") : '' }}</span>
      </div>
    </div>
  </el-dialog>
</template>
<style>
.el-table .warning-row {
  background: #ffaa96;
}
</style>
<script>
import QRCode from "qrcodejs2";
export default {
  name: "EzzDialogForm",
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function() {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      products: [],
      formEmptyData: {
        id: "0",
        PT: "",
        count: "",
        sampleName: "",
        details: [],
        creater_name: sessionStorage.getItem("operator"),
        creater_id: sessionStorage.getItem("operator_id")
      },
      operator_id: sessionStorage.getItem("operator_id"),
      formStatus: false,
      arrayPrint: {
        sampleName: "",
        PT: "",
        createDateStr: "",
        details: []
      }
    };
  },
  beforeCreate: function() {},
  created: function() {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData));
    this.loadProducts()
  },
  mounted: function() {},
  methods: {
    // 加载数据
    loadProducts: function () {
      const _this = this
      _this.post(_this.$apis.getProductsForMakebook, {}, function (res) {
        const _json = res.data
        _this.products = _json.products
      })
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.formData.operator_id = _this.operator_id;
      _this.post(
        _this.$apis.getProductPrintNoteDetail,
        _this.formData,
        function(res) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            _this.products = _json.products
            if (_json.datalist.length === 1) {
              _this.formData.sampleName = _json.datalist[0].sampleName;
              _this.formData.PT = _json.datalist[0].pt;
              _this.formData.count = _json.datalist[0].volumes;
              _this.formData.details = _json.datalist;
              // 重新设计打印数据架构
              _this.arrayPrint = {
                sampleName: "",
                PT: "",
                createDateStr: "",
                details: []
              };
              if (_this.formData.details.length > 0) {
                _this.arrayPrint.sampleName =
                  _this.formData.details[0].sampleName;
                _this.arrayPrint.PT = _this.formData.details[0].pt;
                _this.arrayPrint.createDateStr =
                  _this.formData.details[0].createDateStr;
                _this.arrayPrint.details.push(_this.formData.details[0]);
              }
            } else if (_json.datalist.length === 0) {
              _this.$message({
                type: "error",
                message: "查无数据"
              });
            } else {
              _this.$message({
                type: "error",
                message: "当前托盘号查出包含多种样本册，请去产量表确认数据"
              });
            }
          }
        }
      );
    },
    close: function() {
      this.$confirm("确定关闭？", "提示", {})
        .then(_ => {
          this.isShow = false;
        })
        .catch(_ => {
          return false;
        });
    },
    searchHandler: function() {
      let _this = this;
      if (_this.formData.sampleName === "") {
        _this.$message({
          type: "error",
          message: "样本册不能为空"
        });
        return false;
      } else if (_this.formData.PT === "") {
        _this.$message({
          type: "error",
          message: "托盘号不能为空"
        });
      }else {
        _this.loadData();
      }
    },
    printHandler: function() {
      let _this = this;
      _this.$refs.codeItem.innerHTML = "";
      // 先判断当前查询数据在不在新数据库中，如果不在插入新数据库。
      _this.post(_this.$apis.asyncMakebookSealoutput, _this.formData, function(
        res
      ) {
        let _json = res.data;
        new QRCode(_this.$refs.codeItem, {
          // 二维码内容
          text:
            "PT," +
            _this.formData.PT +
            "," +
            _json.id +
            "," +
            _this.formData.count +
            "," +
            _this.formData.sampleName,
          width: 300,
          height: 300,
          // 二维码颜色
          colorDark: "#333333",
          // 二维码背景色
          colorLight: "#ffffff"
        });
        setTimeout(() => {
          const style =
            "@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}";
          _this.$print({
            printable: "print_area",
            type: "html",
            style: style,
            scanStyles: false
          });
        }, 200);
        _this.parent.loadData();
      });
    },
    addHandler: function() {
      this.formData = JSON.parse(JSON.stringify(this.formEmptyData));
      this.formData.id = "0";
      this.isShow = true;
      this.formStatus = true;
    },
    viewHandler: function(formId) {
      this.formData = JSON.parse(JSON.stringify(this.formEmptyData));
      this.formData.id = formId;
      this.loadData();
      this.isShow = true;
      this.formStatus = false;
    }
  },
  components: {}
};
</script>
